export default __webpack_public_path__ + "static/media/co-like-color.1b79ed49.svg";